import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// Fetch
import { imagePost } from '../../../api/fetch';
// Material Imports
import { Button } from '@material-ui/core';
// Redux
import { useDispatch, useSelector } from 'react-redux';
// Global Components
import CustomTextField from '../../../components/CustomTextField';
// Icon
import ImageUpload from '../../../assets/image-upload.svg';
import CloseIcon from '@material-ui/icons/Close';
import './styles.scss';
import { openSnackBar } from '../../../actions/snackbarAction';

export default function QuestionSubmitForm(props) {
  // State
  const [filePath, setFilePath] = useState('');
  const [isImageUploading, setIsImageUploading] = useState(false);
  // const [isCompressing, setIsCompressing] = useState(false);
  const [state, setState] = useState({
    title: '',
    desc: '',
    image: '',
    isFetching: false
  });
  // Redux
  const dispatch = useDispatch();
  const jwt = useSelector(state => get(state, 'loginReducer.data.jwt', ''));
  const userType = useSelector(state =>
    get(state, 'loginReducer.userType', '')
  );
  // const profileName = useSelector(state =>
  //   get(
  //     state,
  //     'loginReducer.data.profile.FullName',
  //     get(state, 'loginReducer.data.profile[0].FirstName', '')
  //   )
  // );
  //   Functions

  const onCameraSuccess = async (e, dataType) => {
    const file = Array.from(e.target.files);
    if (!file[0].type.includes('image')) {
      return dispatch(
        openSnackBar({
          message: 'Unsupported file format',
          severity: 'error'
        })
      );
    }
    if (file[0].size > 512000) {
      return dispatch(
        openSnackBar({
          message: 'The file is too large. Max allowed size is 512kb',
          severity: 'error'
        })
      );
    }
    setIsImageUploading(true);
    const formData = new FormData();
    const dataURI = await fileToDataUri(file[0]);
    const blobFile = await dataURLtoBlob(dataURI);
    formData.append('user_picture', blobFile, 'user_picture.jpg');
    await imagePost(
      userType === 'student'
        ? 'api/uploaddoubtimage'
        : dataType === 'image'
          ? 'api/facultyuploaddoubtimage'
          : 'api/submitvideo',
      jwt,
      formData
    )
      .then(resp => {
        if (resp.error && !resp.data) {
          //   dispatch(
          //     openSnackBar({
          //       message: JSON.parse(resp.data).message,
          //       severity: 'error'
          //     })
          //   );
          setFilePath('');
          props.setVideoFile('');
          return setIsImageUploading(false);
        }
        setIsImageUploading(false);
        if (dataType === 'image') {
          setFilePath(
            // `https://dc.allenbpms.in/UploadWhizkids6020FF09/document/${resp.data}`
            URL.createObjectURL(file[0])
          );
          setState({
            ...state,
            image: resp.data
          });
        } else {
          setState({
            ...state,
            video: resp.data
          });
          props.setVideoFile(resp.data);
        }
      })
      .catch(err => {
        console.log('Error -', err);
        setIsImageUploading(false);
        setState({
          ...state,
          image: '',
          video: ''
        });
        setFilePath('');
        props.setVideoFile('');
      });
  };

  const fileToDataUri = file =>
    new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = event => {
        resolve(event.target.result);
      };
      reader.readAsDataURL(file);
    });

  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const onFormSubmit = async () => {
      var sendQuestionData =await (userType === 'student'? {
        title: state.title,
        decription: state.desc,
        imageURL: state.image,
        forumID: props.forumId,
        userType: props.userType,
        userID:0,
        jwtToken:props.jwtToken,
      }:{
        title: state.title,
        decription: state.desc,
        imageURL: state.image,
        forumID: props.forumId,
        userType: props.userType,
        userID:0,
        jwtToken:props.jwtToken,
        videoURL:state.video,
      });
  
      props.questionHubData(JSON.stringify(sendQuestionData));





    setState({
      ...state,
      title: '',
      desc: '',
      image: '',
      isFetching: false
    });
    setFilePath('');
    props.setVideoFile('');
    // props.onRefresh();
  };

  return (
    <div className="doubt-submit-form">
      <CustomTextField
        id="title"
        value={state.title}
        label={
          userType === 'student'
            ? 'Enter your doubt title'
            : 'Enter your question title'
        }
        color="secondary"
        helperText="(Max 200 Char)"
        fullWidth
        maxLength={200}
        onChange={e =>
          setState({
            ...state,
            title: e.target.value
          })
        }
      />
      <CustomTextField
        id="desc"
        label={
          userType === 'student'
            ? 'Enter your doubt description'
            : 'Enter your question description'
        }
        value={state.desc}
        color="secondary"
        fullWidth
        multiline
        rows={4}
        maxLength={600}
        helperText="(Max 600 Char)"
        onChange={e =>
          setState({
            ...state,
            desc: e.target.value
          })
        }
      />
      <h5 className="mt-20">Doubt Image (Max 512Kb)</h5>
      <div className="upload-image-container">
        {isImageUploading ? (
          <div className="loader">...Loading</div>
        ) : filePath || props.videoFile ? (
          <div className="image">
            <img src={filePath || props.videoFile} />
            <span className="close" onClick={() => {
                  setFilePath('')
                  setState({
                    ...state,
                    image: '',
                    isFetching: false,
                  });  }}>
              <CloseIcon />
            </span>
          </div>
        ) : (
              <div className="image-upload">
                <label htmlFor="file-input">
                  <img src={ImageUpload} />
                </label>

                <input
                  id="file-input"
                  type="file"
                  accept="image/*"
                  onChange={e => onCameraSuccess(e, 'image')}
                />
              </div>
            )}
      </div>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => onFormSubmit()}
      >
        {userType === 'student' ? 'Submit Doubt' : 'Submit Question'}
      </Button>
    </div>
  );
}

QuestionSubmitForm.propTypes = {
  forumCode: PropTypes.string,
  videoFile: PropTypes.string,
  onRefresh: PropTypes.func,
  showCamera: PropTypes.func,
  setVideoFile: PropTypes.func,
  profileImage: PropTypes.string,
  forumId: PropTypes.number,
  userType: PropTypes.number,
  jwtToken: PropTypes.string,
  questionHubData:PropTypes.func
 
};
